module.exports = __webpack_public_path__ + "img/defualt-tx.d22a05ad.png";